<template>
  <div>
    <v-row v-if="isMobile" align="stretch">
      <v-col class="d-flex justify-center align-center" cols="12">
        <v-avatar class="mt-4" :color="color" size="80">
          <v-icon dark x-large> mdi-calendar-check-outline </v-icon>
        </v-avatar>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h1 :class="['headline text-h4 font-weight-bold text-center', dark ? 'white--text' : '']">
          {{ $t("bookingForm.BookingStart.introText") }}
        </h1>
        <div class="text-caption mb-4 mt-4 mx-4 text-center">
          <span class="mr-1">
            {{ partner.companyName }}
          </span>
          <span> - </span>
          <span v-if="partner.address" class="ml-1">
            {{ partner.address.street }},
            {{ partner.address.zip }}
            {{ partner.address.city }}
          </span>
        </div>
      </v-col>
      <v-col cols="12" v-if="!isMobile">
        <v-list-item-subtitle :class="['text-center', 'text-h6', dark ? 'white--text' : '']">
          {{ $t("bookingForm.BookingStart.introSubText") }}
        </v-list-item-subtitle>
      </v-col>
    </v-row>
    <v-row :style="isMobile ? 'min-height:290px' : ''" class="px-4 d-flex flex-column" align="center" justify="center">
      <!-- How to book 3 items -->
      <v-list v-if="isMobile || bookingIframe" :dark="dark">
        <v-list-item v-for="item in items" :key="item.title">
          <v-list-item-icon>
            <v-icon :dark="dark">
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-left">
            <v-list-item-title class="">{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle class="">{{ item.subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-row>
    <v-row style="min-height: 60px"> <v-col> </v-col></v-row>
    <div class="px-4">
      <v-btn v-if="isMobile" class="mb-4" @click="start" block :color="color" dark elevation="0">
        {{ $t("bookingForm.BookingStart.bookButton") }}
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { AvailabilityModule } from "@/store/modules/availability.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BookingStart extends Vue {
  @Prop({ default: false })
  isMobile!: boolean;

  @Prop({ default: false })
  dark!: boolean;

  /**
   * Flag if booking is used in an iframe(design should not change)
   */
  @Prop({ default: false })
  bookingIframe!: boolean;

  start() {
    AvailabilityModule.setServices();
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get partner() {
    return PartnerModule.partner;
  }

  get items() {
    return [
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("bookingForm.BookingStart.item1.title"),
        subtitle: this.$t("bookingForm.BookingStart.item1.subtitle")
      },
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("bookingForm.BookingStart.item2.title"),
        subtitle: this.$t("bookingForm.BookingStart.item2.subtitle")
      },
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("bookingForm.BookingStart.item3.title"),
        subtitle: this.$t("bookingForm.BookingStart.item3.subtitle")
      }
    ];
  }
}
</script>
<style scoped></style>
